import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CtaLayout1Component } from '@components/cta/components/cta-layout-1';
import { CtaLayout2Component } from '@components/cta/components/cta-layout-2';
import { CtaLayout } from '@components/cta/config';
import { ComponentLoaderAbstract } from '@services/component-loader';
import { Layout } from '@shared/models';

@Component({
  selector: 'app-cta',
  imports: [CtaLayout1Component, CtaLayout2Component],
  templateUrl: './cta.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtaComponent extends ComponentLoaderAbstract<Layout<CtaLayout>> {
  readonly layout = CtaLayout;
}
